
class CatalogModuleLogic {
  identificationEventModule; 
  appContext;
  framework;

  constructor(_identificationEventModule,_appContext,_framework) {
    this.identificationEventModule = _identificationEventModule;
    this.appContext = _appContext;
    this.framework = _framework;
  }


  async fetchCheckinProjectArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchCheckinProjectArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  } 

  async addCheckinProject(_checkinProject,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().addCheckinProject(_checkinProject,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }      

  async editCheckinProject(_checkinProject,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().editCheckinProject(_checkinProject,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }

  async removeCheckinProject(_checkinProject,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().removeCheckinProject(_checkinProject,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }    
  
  async fetchMerchantAccountArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchMerchantAccountArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  } 

  async addMerchantAccount(_merchantAccount,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().addMerchantAccount(_merchantAccount,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }      

  async editMerchantAccount(_merchantAccount,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().editMerchantAccount(_merchantAccount,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }

  async removeMerchantAccount(_merchantAccount,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().removeMerchantAccount(_merchantAccount,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }     


  async fetchMerchantProductArray(condition,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchMerchantProductArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  } 

  async addMerchantProduct(_merchantProduct,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().addMerchantProduct(_merchantProduct,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }      

    async addMultiMerchantProduct(_addMultiMerchantProductRequest,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().addMultiMerchantProduct(_addMultiMerchantProductRequest,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }

  async editMerchantProduct(_merchantProduct,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().editMerchantProduct(_merchantProduct,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }

  async removeMerchantProduct(_merchantProduct,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().removeMerchantProduct(_merchantProduct,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }     

  async fetchEcosystemDeviceArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchEcosystemDeviceArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  } 

  async addEcosystemDevice(_ecosystemDevice,_successCallback,_errorCallback) {
    console.log("_ecosystemDevice");
    console.log(_ecosystemDevice);
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().addEcosystemDevice(_ecosystemDevice,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }      

  async editEcosystemDevice(_ecosystemDevice,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().editEcosystemDevice(_ecosystemDevice,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }

  async removeEcosystemDevice(_ecosystemDevice,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().removeEcosystemDevice(_ecosystemDevice,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  } 

  async fetchServiceTableArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchServiceTableArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  } 

  async addServiceTable(_serviceTable,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().addServiceTable(_serviceTable,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }      

  async editServiceTable(_serviceTable,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().editServiceTable(_serviceTable,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }

  async removeServiceTable(_serviceTable,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().removeServiceTable(_serviceTable,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }     
  
  async fetchServiceSequenceArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchServiceSequenceArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  } 

  async addServiceSequence(_serviceSequence,_successCallback,_errorCallback) {
    console.log("_serviceSequence");
    console.log(_serviceSequence);
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().addServiceSequence(_serviceSequence,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }      

  async editServiceSequence(_serviceSequence,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().editServiceSequence(_serviceSequence,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }

  async removeServiceSequence(_serviceSequence,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().removeServiceSequence(_serviceSequence,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }      

  async fetchCheckinZoneArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchCheckinZoneArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  } 

  async addCheckinZone(_checkinZone,_successCallback,_errorCallback) {
    console.log("_checkinZone");
    console.log(_checkinZone);
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().addCheckinZone(_checkinZone,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }      

  async editCheckinZone(_checkinZone,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().editCheckinZone(_checkinZone,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }

  async removeCheckinZone(_checkinZone,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().removeCheckinZone(_checkinZone,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  } 
  
  async fetchGatewayPassageArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchGatewayPassageArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  } 

  async addGatewayPassage(_gatewayPassage,_successCallback,_errorCallback) {
    console.log("_gatewayPassage");
    console.log(_gatewayPassage);
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().addGatewayPassage(_gatewayPassage,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }      

  async editGatewayPassage(_gatewayPassage,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().editGatewayPassage(_gatewayPassage,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }

  async removeGatewayPassage(_gatewayPassage,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().removeGatewayPassage(_gatewayPassage,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }      

}


export default CatalogModuleLogic;